import { render, staticRenderFns } from "./waresGoodsManage.vue?vue&type=template&id=7c8d8b01&scoped=true&"
import script from "./waresGoodsManage.vue?vue&type=script&lang=js&"
export * from "./waresGoodsManage.vue?vue&type=script&lang=js&"
import style0 from "./waresGoodsManage.vue?vue&type=style&index=0&id=7c8d8b01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d8b01",
  null
  
)

export default component.exports